module.exports = __webpack_public_path__ + "static/img/mIcon3@2x.f2488aa6.png";